<template>
  <PersonalInformation/>
</template>

<script>
import PersonalInformation from './PersonalInformation'
export default {

  name:'information-page',

  components:{
    PersonalInformation
  }
}
</script>